import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import ProjectTablesLayer from '../components/ProjectTablesLayer';

const ProjectTablesPage = () => (
  <MasterLayout pageTitle='Project Tables'>
    <ProjectTablesLayer />
  </MasterLayout>
);

export default ProjectTablesPage;
